export * from './SyntheticDOM';


//////////////////
// WEBPACK FOOTER
// ../synthetic-dom/esm/main.js
// module id = 963
// module chunks = 22